import { render } from "./LoginDialog.vue?vue&type=template&id=1dd7a1a7&scoped=true"
import script from "./LoginDialog.vue?vue&type=script&lang=js"
export * from "./LoginDialog.vue?vue&type=script&lang=js"

import "./LoginDialog.vue?vue&type=style&index=0&id=1dd7a1a7&scoped=true&lang=less"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd7a1a7"]])

export default __exports__